import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuthState } from "react-firebase-hooks/auth";
import { auth } from "../firebase";
import "../styles/style.css";
import adnu_logo from "../assets/images/adnu_logo.png";
import rs_logo_f from "../assets/images/roadsense_logo_full.png";

import NavbarLanding from "../components/Navbar/NavbarLanding";

function Index() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [user, loading, error] = useAuthState(auth);
  const navigate = useNavigate();
  useEffect(() => {
    if (loading) {
      // for loading screen
      return;
    }
    if (user) navigate("/Dashboard");
  }, [user, loading]);
  return (
    <div className="background">
        <NavbarLanding />
        <div className="about_wrapper">
        <div className="about_wrapper_inner">
          <h1>What is Roadsense?</h1>
          <p>The project called RoadSense will serve as the fundamental cornerstone of learners’ future expectations and experiences. Providing an accurate representation of various scenes on the website is of paramount importance. The content of this interactive web-based learning platform will be extensively explored throughout this paper. These discussions will encompass specific ideas, theories, and topics that are directly relevant to this study, along with an in-depth exploration of the development process behind RoadSense, including the tools, software, and hardware employed.</p>
          <h3>Lesson Sources:</h3>
          <a href="https://portal.lto.gov.ph/ords/f?p=ELEARNING:HOME:106251429231652:::HOME:P1_ELEARN_TOPICS_FK:ORC">LTO LTMS PORTAL E-LEARNING</a>
          <h1>About Us</h1>
          Driving is a daily activity that surrounds us and safety is its partner. By having an interactive website that helps people to learn the basics of road safety, accidents can be prevented. Along the way, this website will be beneficial not only to drivers, but also to the community around us - this is RoadSense.
        </div>
        </div>
    </div>
  );
}

export default Index;
